import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/atendimento/conselhos${queryUrl}`)
  },
  insertNewConselho(data) {
    return axios.post('/atendimento/conselhos', data)
  },
  editConselho(data) {
    return axios.put(`/atendimento/conselhos/${data.id}`, data)
  },
  deleteConselho(id) {
    return axios.delete(`/atendimento/conselhos/${id}`)
  },
}
